import React, { useContext, useMemo, useState } from 'react';
// eslint-disable-next-line no-unused-vars
import styled from 'styled-components/macro';

import DataLayout from '../components/molecules/DataLayout';
import Pagination from '../components/molecules/Pagination';
import Table from '../components/molecules/Table';
import FiltersJSX from '../components/organisms/FilterJSX';
import Button from '../components/atoms/Button';
import StoreGroupDetail from '../components/organisms/StoreGroupDetail';
import ModalContainer from '../components/molecules/ModalContainer';
import StoreService from '../services/storeService';
import ConfirmationDialogueModal from '../components/organisms/ConfirmationDialogueModal';
import CreateStoreGroup from '../components/organisms/CreateStoreGroup';
import Toast from '../components/molecules/Toast';
import { AuthContext } from '../context/authContext';
import { no_permission } from '../helpers/common';

function StoreGroups() {
  const [searchQuery, setSearchQuery] = useState({
    searchText: '',
    filterText: 'All',
    startDate: '',
    endDate: '',
    page: 1,
    pageSize: 10,
    sortBy: 'created_at',
    sortOrder: -1,
  });
  const { fetch, refetch } = useContext(AuthContext);
  const [activeKey, setActiveKey] = useState('');
  const { storeGroups_data } = StoreService.GetStoreGroups(searchQuery, fetch);

  const onDeleteStoreGroup = id => {
    StoreService.deleteStoreGroups(id)
      .then(() => {
        refetch();
        Toast({
          type: 'success',
          message: 'Store Group Deleted Successfully',
        });
      })
      .catch(es => {
        Toast({
          type: 'error',
          message: es.message,
        });
      });
  };

  const dummyData = [
    {
      group_name: 'Store 1',
      _id: '1',
      store_id: '12345',
      length: '5',
      status: 'Pending',
      address: { street_address: '123 Main St', city: 'San Francisco', state: 'CA' },
    },
    {
      group_name: 'Store 1',
      _id: '2',
      store_id: '12345',
      length: '5',
      status: 'Active',
      address: { street_address: '123 Main St', city: 'San Francisco', state: 'CA' },
    },
    {
      group_name: 'Store 1',
      _id: '3',
      store_id: '12345',
      length: '5',
      status: 'Pending',
      address: { street_address: '123 Main St', city: 'San Francisco', state: 'CA' },
    },
    {
      group_name: 'Store 1',
      _id: '4',
      store_id: '12345',
      length: '5',
      status: 'Active',
      address: { street_address: '123 Main St', city: 'San Francisco', state: 'CA' },
    },
  ];

  const { store_groups, totalItems } = useMemo(
    () => ({
      store_groups: dummyData
        .map(stg => [
          stg.group_name,

          stg.length,
          <ModalContainer
            title="More Details"
            xl
            btnComponent={({ onClick }) => (
              <Button
                type="light"
                width={75}
                xs
                onClick={() => {
                  onClick();
                }}>
                More
              </Button>
            )}
            content={() => <StoreGroupDetail group_id={stg._id} />}
          />,
          stg.status,
          <ModalContainer
            title="Update Store Group"
            xl
            btnComponent={({ onClick }) => (
              <Button unStyled onClick={onClick} disabled={stg.status === 'Active'}>
                <i className="icon-pencil" />
              </Button>
            )}
            content={({ onClose }) => <CreateStoreGroup onClose={onClose} group={stg} />}
          />,
          <ModalContainer
            title="Delete Store Group"
            btnComponent={({ onClick }) => (
              <button
                disabled={stg.status === 'Active'}
                type="button"
                onClick={() => {
                  onClick();
                }}
                css={`
                  color: ${stg.status === 'Active' ? 'var(--gray)' : 'var(--danger);'};
                `}>
                Delete
              </button>
            )}
            content={({ onClose }) => (
              <ConfirmationDialogueModal
                onClose={onClose}
                text="You are about to delete a store group. Would you like to continue?"
                btn={
                  <Button type="danger" width={215} onClick={() => onDeleteStoreGroup(stg._id)}>
                    Delete
                  </Button>
                }
              />
            )}
          />,
        ])
        .reduce((prev, curr) => {
          prev.push(curr.filter(item => item !== no_permission));
          return prev;
        }, []),
      totalItems: storeGroups_data.totalItems,
    }),
    [storeGroups_data],
  );

  const columnNames = [
    { name: `Group Name`, sort: true, sortKey: 'group_name' },
    { name: `Store Count`, sort: false },
    { name: `Details`, sort: false },
    { name: `Status`, sort: false },
    { name: `Edit`, sort: false },
    { name: `Action`, sort: false },
  ];

  return (
    <>
      <DataLayout
        title="Store Groups"
        filters={
          <FiltersJSX
            onFilterChange={__ => {
              setSearchQuery(_ => ({
                ..._,
                ...__,
                page: 1,
                pageSize: 10,
                filterText: __.filterText !== 'All' ? __.filterText : '',
              }));
            }}
            setActiveKey={setActiveKey}
          />
        }>
        <Table
          rowsData={store_groups}
          columnNames={columnNames}
          loading={false}
          itemsPerPage={searchQuery.pageSize}
          onSort={(sortBy, sortOrder) => {
            const newSearchQuery = { ...searchQuery, sortBy, sortOrder };
            setSearchQuery(newSearchQuery);
          }}
          activeKey={activeKey}
          setActiveKey={setActiveKey}
        />
        <Pagination
          className="pagination-bar"
          currentPage={searchQuery.page}
          totalCount={totalItems}
          pageSize={searchQuery.pageSize}
          onPageChange={page => {
            setSearchQuery(_ => ({ ..._, page }));
          }}
          onPageSizeChange={pageSize => {
            setSearchQuery(_ => ({ ..._, pageSize, page: 1 }));
          }}
        />
      </DataLayout>
    </>
  );
}

export default StoreGroups;
